import React, { useState, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { authService, AuthState } from '../../data/sync/authService';

export const ProtectedRoute: React.FC = () => {
  const location = useLocation();
  const [authState, setAuthState] = useState<AuthState>(authService.getState());

  useEffect(() => {
    const unsub = authService.subscribe((state) => {
      setAuthState(state);
    });
    return unsub;
  }, []);

  if (authState.isLoading) {
    return (
      <div
        className="min-h-screen bg-canvas flex flex-col items-center justify-center p-4"
        role="status"
        aria-label="Checking authorization"
      >
        <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-brand to-brand-hover text-white flex items-center justify-center shadow-md animate-pulse mb-4">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" className="w-6 h-6">
            <path d="M12 3v18M18 7l-6-4-6 4M18 17l-6 4-6-4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <div className="h-1.5 w-32 bg-surface-3 rounded-full overflow-hidden">
          <div className="h-full bg-brand rounded-full animate-pulse" />
        </div>
      </div>
    );
  }

  if (!authState.user) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  return <Outlet />;
};
